import { Badge, type BadgeProps } from "~/components/design-system/components"
import { Tooltip } from "~/components/reusable/Tooltip"
import { useFlags } from "~/features/feature-flags"

/**
 * Source badge for adjustment rows that represent forecast edits made on the
 * Forecast Updates page (ForecastVariantLocked type='MonthlyAdjust'), as
 * opposed to manually created adjustments. Attach it only to the row that
 * represents the edit itself, never to regular adjustments. The tooltip states
 * how edits and adjustments combine, which depends on the reviewForecasts flag
 * (saveMonthlyForecastAdjust's reapplyAdjustments path).
 */
export function ForecastEditBadge({ size = "sm" }: { size?: BadgeProps["size"] }) {
  const { reviewForecasts } = useFlags()
  const interaction = reviewForecasts
    ? "Adjustments still apply on top of the edited values."
    : "Adjustments do not change the edited months."
  return (
    <Tooltip
      title={`The forecast for these months was typed in directly on the Forecast Updates page, not created as an adjustment. ${interaction} To change or undo it, edit the forecast on Forecast Updates.`}
    >
      <span className="inline-flex">
        <Badge variant="blue" size={size}>
          Forecast Updates
        </Badge>
      </span>
    </Tooltip>
  )
}
